export default __webpack_public_path__ + "static/media/cp-userInfo.671276eb.png";